import { PlusIcon } from "@phosphor-icons/react/ssr";
import Paragraph from "~/componentsDS/Typography/Paragraph";

type StepPillProps = {
    label: string;
    onClick: () => void;
    id: string;
    controlsId: string;
};

const StepPill = ({ label, onClick, id, controlsId }: StepPillProps) => {
    return (
        <button
            type="button"
            role="tab"
            id={id}
            aria-selected={false}
            aria-controls={controlsId}
            tabIndex={-1}
            onClick={onClick}
            className="
                flex items-center gap-2.5 rounded-full px-6 py-4
                transition-all duration-300 ease-out
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary300 focus-visible:ring-offset-2
                bg-primary500 text-pureWhite group
            ">
            <div className="
                flex items-center justify-center w-8 h-8
                rounded-full border-[2px] border-pureWhite/25 bg-pureWhite/5
                transition-colors duration-200
                group-hover:bg-primary300 group-hover:border-primary300
            ">
                <PlusIcon size={20} className="text-pureWhite shrink-0" />
            </div>
            <Paragraph size="lg" className="pt-[2px]">{label}</Paragraph>
        </button>
    );
};

export default StepPill;
